module.exports = __webpack_public_path__ + "static/files/acv_journal1.7001005.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acv_journal1.pdf
// module id = MpmK
// module chunks = 0